<form
  class="audio-upload"
  [formGroup]="AudioForm"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  fxLayoutGap="10px"
>
  <label
    *ngrxLet="uploadCompleted$ as uploadCompleted"
    [className]="isSelectAudioDisabled ? 'audio-upload__label__disabled' : 'audio-upload__label'"
    >{{ uploadCompleted || isFileToEdit ? 'Audio: ' + filePath?.value?.split('/').pop() : '' }}</label
  >
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
    <input
      class="audio-upload__file-input"
      #fileInput
      type="file"
      [accept]="supportedFileExtensions"
      (change)="handleFileInput($event)"
    />
    <button
      *ngrxLet="uploadCompleted$ as uploadCompleted"
      [disabled]="isSelectAudioDisabled"
      mat-button
      color="primary"
      type="button"
      fxFlexAlign="start"
      (click)="uploadCompleted || isFileToEdit ? resetFile() : fileInput.click()"
      matTooltip="Please be aware that .ogg and .webm formats are not supported by iOS and therefore are not playable on Apple devices"
      matTooltipPosition="right"
    >
      {{ uploadCompleted || isFileToEdit ? ('Remove ' + uploadedFileType | uppercase) : ('Select audio' | uppercase) }}
    </button>
    <mat-progress-bar
      *ngIf="uploadIsInProgress$ | async"
      color="accent"
      mode="determinate"
      [value]="uploadProgress$ | async"
    ></mat-progress-bar>
  </div>
</form>
